import { Component } from '@angular/core';

@Component({
    selector: 'app-project-home',
    standalone: true,
    imports: [],
    templateUrl: './project-home.html',
    styleUrl: './project-home.css',
})
export class ProjectHome {}
